<template>
    <h2 class="d-inline-block" style="position: relative;">
        <div v-if="$router.currentRoute.name == 'mediaCallPage'" class="media-call-icon" :class="!userAbilities.createMediaCall ? 'pointer-default' : ''" @click="userAbilities.createMediaCall ? createMediaCall() : ''">
            <img :src="require(`@/csmworkflow/img/media-call.svg`)"/>
            <span class="add-media-call-icon" >
                <img src="@/csmworkflow/img/add-icon.svg"/>
            </span>
        </div>
        <div v-else class="media-call-icon" :class="!userAbilities.createMediaCall ? 'pointer-default' : ''" @click="userAbilities.createMediaCall ? clickDeliverableIcon() : ''">
            <img :src="require(`@/csmworkflow/img/${deliverableIcon}.svg`)"/>
            <span class="add-media-call-icon" >
                <img src="@/csmworkflow/img/add-icon.svg"/>
            </span>
        </div>
        <transition name="deliverable-buttons-fade">
        <div class="all-deliverable-buttons" v-if="showAllAddButton && hasMultipleDeliverableType && userAbilities.createMediaCall">
            <div class="media-call-icon" v-for="(type,i) in deliverableTypes" :key="i" @click="createDeliverable(type)">
                <img :src="require(`@/csmworkflow/img/${type.typeIcon}.svg`)"/>
                <span class="add-media-call-icon" >
                    <img src="@/csmworkflow/img/add-icon.svg"/>
                </span>
            </div>
        </div>
        </transition>
        {{deliverableTitle}}
        <span class="text-muted" v-if="showDeliverableCount">({{deliverableCount}} deliverable<span v-if="deliverableCount !== 1">s</span><span v-if="$router.currentRoute.name != 'socialMedia' && $router.currentRoute.name != 'socialMediaGrouped' && $router.currentRoute.name != 'socialMediaSchedule'">, {{totalOutletCount}} calls</span>)</span>
        <span class="text-muted" v-if="showDeliverableCountMyWeek">
            <a href="#" @click="overdueClick('overdue')"  :style="{backgroundColor: getBgColor('overdue')}" v-if="deliverableCount['overdue']>0">({{deliverableCount['overdue']}} overdue</a>
            <a href="#" @click="overdueClick('overdue')"  :style="{backgroundColor: getBgColor('overdue'), pointerEvents:'none', texDecoration: 'none', color: '#ccc'}" v-else>({{deliverableCount['overdue']}} overdue</a>,
            <a href="#" @click="overdueClick('today')"  :style="{backgroundColor: getBgColor('today')}" v-if="deliverableCount['today']>0" >{{deliverableCount['today']}} today</a>
            <a href="#" @click="overdueClick('today')"  :style="{backgroundColor: getBgColor('today'), pointerEvents:'none', texDecoration: 'none', color: '#ccc'}" v-else>{{deliverableCount['today']}} today</a>,
            <a href="#" @click="overdueClick('thisWeek')" :style="{backgroundColor: getBgColor('thisWeek')}" v-if="deliverableCount['thisWeek']>0"  >{{deliverableCount['thisWeek']}} this week</a>
            <a href="#" @click="overdueClick('thisWeek')" :style="{backgroundColor: getBgColor('thisWeek'), pointerEvents:'none', texDecoration: 'none', color: '#ccc'}"  v-else>{{deliverableCount['thisWeek']}} this week</a>,
            <a href="#" @click="overdueClick('nextWeek')" :style="{backgroundColor: getBgColor('nextWeek')} "  v-if="deliverableCount['nextWeek']>0">{{deliverableCount['nextWeek']}} next week</a>
            <a href="#" @click="overdueClick('nextWeek')" :style="{backgroundColor: getBgColor('nextWeek'), pointerEvents:'none', texDecoration: 'none', color: '#ccc' }"  v-else>{{deliverableCount['nextWeek']}} next week</a>,
            <a href="#" @click="overdueClick('upcoming')" :style="{backgroundColor: getBgColor('upcoming')}"  v-if="deliverableCount['upcoming']>0">{{deliverableCount['upcoming']}} upcoming</a>
            <a href="#" @click="overdueClick('upcoming')" :style="{backgroundColor: getBgColor('upcoming'), pointerEvents:'none', texDecoration: 'none', color: '#ccc' }"  v-else >{{deliverableCount['upcoming']}} upcoming</a>,
            <a href="#" @click="overdueClick('noDeadline')"  :style="{backgroundColor: getBgColor('noDeadline')}"   v-if="deliverableCount['noDeadline']>0">{{deliverableCount['noDeadline']}} no deadline</a>
            <a href="#" @click="overdueClick('noDeadline')"  :style="{backgroundColor: getBgColor('noDeadline'), pointerEvents:'none', texDecoration: 'none', color: '#ccc' }"  v-else >{{deliverableCount['noDeadline']}} no deadline</a>
          )
        </span>
        <!-- <span v-html="title"></span> -->
    </h2>
</template>
<script>
import { mapGetters } from 'vuex';
    export default {
        components: {

        },
        props: {
            totalDeliverableCount: Number,
            totalDeliverableCountNoMasters: Number,
            totalOutletCount: Number,
            myWeek: Boolean,
            isListView: Boolean,
            title: String,
        },
        data() {
            return {
                showAllAddButton: false,
                filterQuery: {},
                pointerEvents:"",
                texDecoration:"",
                textColor:"",
                // weekFilterOptions: {
                //     overdue: false,
                //     today: false,
                //     thisWeek: false,
                //     nextWeek: false,
                //     upcoming: false,
                //     noDeadline: false,
                // }
            };
        },
        computed: {
            ...mapGetters([
                "deliverableTypes",
                "userAbilities",
                "deliverableCount"
            ]),
            deliverableTitle() {
                if (this.$router.currentRoute.name == 'mediaCallPage') {
                    return "All Media Calls";
                } else if(this.$router.currentRoute.name == 'socialMedia' || this.$router.currentRoute.name == 'socialMediaGrouped' || this.$router.currentRoute.name == 'socialMediaSchedule'){
                    return "Social Media";
                } else if (this.myWeek) {
                    if (this.hasMultipleDeliverableType) {
                        return "My Deliverables";
                    } else {
                        return "My " + this.deliverableTypes[0].name + "s";
                    }
                } else {
                    if (this.hasMultipleDeliverableType) {
                        return "All Deliverables";
                    } else {
                        return "All " + this.deliverableTypes[0].name + "s";
                    }
                }
            },
            deliverableIcon() {
                if (this.$router.currentRoute.name == 'socialMedia' || this.$router.currentRoute.name == 'socialMediaGrouped' || this.$router.currentRoute.name == 'socialMediaSchedule') {
                    return "social-media";
                } else if (this.hasMultipleDeliverableType) {
                    // return "@/csmworkflow/img/my-week-list.svg";
                    return "my-week-list";
                }  else {
                    // return `@/csmworkflow/img/${this.deliverableTypes[0].typeIcon}.svg`;
                    return this.deliverableTypes[0].typeIcon;
                }
            },

            hasMultipleDeliverableType() {
                if (!this.deliverableTypes || this.deliverableTypes.length == 0) {
                    return true;
                }
                return this.deliverableTypes.length > 1;
            },

            showDeliverableCount() {
                return this.totalDeliverableCount != null && this.totalOutletCount != null;
            },
            showDeliverableCountMyWeek() {
            	if (this.deliverableCount) {
	                if (this.deliverableCount['today'] > 0){
	                    // this.showLinks();
	                    //  this.pointerEvents = "";
	                    //  this.texDecoration = "";
	                    //  this.textColor = "";
	                }else{
	                    //  this.pointerEvents = "none";
	                    //  this.texDecoration = "none";
	                    //  this.textColor = "#ccc";
	                }
	                return this.deliverableCount && this.myWeek &&
	                    this.deliverableCount['today'] != undefined &&
	                    this.deliverableCount['overdue'] != undefined &&
	                    this.deliverableCount['thisWeek'] != undefined &&
	                    this.deliverableCount['nextWeek'] != undefined &&
	                    this.deliverableCount['upcoming'] != undefined &&
	                    this.deliverableCount['noDeadline'] != undefined
                }
                return null;
            },
            deliverableCount() {
                if(this.isListView){
                    return this.totalDeliverableCountNoMasters;
                }
                return this.totalDeliverableCount;
            }
        },
        methods: {
            expandIcons() {
                this.showAllAddButton = true;
            },
            retractIcons() {
                this.showAllAddButton = false;
            },

            clickDeliverableIcon() {
                if (this.hasMultipleDeliverableType) {
                    this.expandIcons();
                } else {
                    this.createDeliverable(this.deliverableTypes[0]);
                }
            },

            createDeliverable(type) {
                type = type.id;
                let that = this;
                this.$store.dispatch("createNewDeliverable", { type }).then(() => {
                    that.deliverableType = '';
                    that.$bvModal.show("editDeliverableModal");
                    that.$nextTick(() => {
                    $(".edit-deliverable-modal .deliverable-title").trigger("click");
                    });
                    that.$store.dispatch("fetchDeliverables");
                });

                this.retractIcons();
            },

            // Hardcoded
            createMediaCall() {
                this.createDeliverable({
                    id: 'media_call',
                    name: "Media Call",
                })
            },
            addFilter(flag){
                // this.weekFilterOptions[flag] = !this.weekFilterOptions[flag];
            },
             overdueClick(type){
                // this.addFilter(type);
                this.filterQuery = this.$store.getters.myWeekDeliverableFilter;
                if (type == '0'){
                    this.filterQuery.weekFilterOptions = null;
                }else{
                    this.filterQuery.weekFilterOptions[type] =  !this.filterQuery.weekFilterOptions[type];

                }
                this.$store.commit("setDeliverableFilter", this.filterQuery);
                // this.$store.dispatch("fetchDeliverables");

            },

             getBgColor(type){
                this.filterQuery =  this.$store.getters.myWeekDeliverableFilter;

                    this.pointerEvents = "";
                     this.texDecoration = "";
                     this.textColor = "";



                if (typeof this.filterQuery.weekFilterOptions != 'undefined' ){
                      if(this.filterQuery.weekFilterOptions[type]){
                        return "#fff000"
                    }else{
                        return ""
                    }
                }else{
                    return ""
                }

                // if(this.filterQuery.filterTopTest[type]){
                //     return "#fff000"
                // }else{
                //     return "#fff"
                // }
            }
        },
        mounted() {
            document.addEventListener("pointerdown", this.retractIcons);
            this.filterQuery = this.$store.getters.myWeekDeliverableFilter;
            // this.filterQuery.weekFilterOptions =  this.weekFilterOptions;
        },
        created(){
            
        },
        updated(){
            
        },
        destroyed() {
            document.removeEventListener("pointerdown", this.retractIcons);
        },
    }
</script>
